import React from 'react';
import styled from 'styled-components';

import { Col, Separator } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const Column = styled(Col)`
  margin-bottom: ${({ mBottom }) => mBottom}px;
`;

const Title = styled(Text)`
  border-bottom: 2px solid;
  width: max-content;
  text-transform: capitalize;
`;

const MAP = {
  event_name: 'event name',
  event_cooldown: 'Within time period',
};

const ReferralValidityCriteria = ({ validityCriteria }) => {
  return (
    <>
      {Object.entries(validityCriteria)?.map(([key, value], i) => {
        return (
          <Column mBottom={24} key={key}>
            <Title variant="h4">{key}</Title>
            <Separator height={16} transparent />
            {value?.map((el, j) => {
              return (
                <Column mBottom={24} gutter={0} key={`${key}-${i}-${j}`}>
                  {Object.entries(el)?.map(([l, m], k) => {
                    const valueToDisplay = isNaN(m) ? m : `${m / (60 * 60 * 24)} days`;
                    return (
                      <Column mBottom={4} key={`${l}-${i}-${j}-${k}`}>
                        <Text variant="eyebrow2">{MAP[l] || l}</Text>
                        <Text variant="h6">{MAP[valueToDisplay] || valueToDisplay}</Text>
                      </Column>
                    );
                  })}
                </Column>
              );
            })}
          </Column>
        );
      })}
    </>
  );
};

export default ReferralValidityCriteria;
